import GeneralHelper from "./generalHelper"
import View from "./View"
import Category from "./category"

export const General = Object.freeze({
  margin : 2 ,
  transparency : 0.65 ,
  default_header_name : 'default-header' ,
  category_root_level : 3
});

export const Type = Object.freeze({
  designer  : 'designer',
  category  : 'category',
  logo_document : 'logo',
  header_document :'header'
});

export const Ids = Object.freeze({
  logo       : 'metafile-logo',
  copyrights : 'metafile-copyrights',
  header     : 'metafile-header',
  pattern_name : 'metafile-pattern_name'
});

// ********************* HELPERS
export default class MetaFiles
{
  static get_tag_level(parent)
  {
    var words = parent.split(/[/]+/) ;
    return Cx_.filter(words, function(word) { return (word.length > 0); }).length ;
  }

  static get_child_tag(tags, parent)
  {
    var tag = Cx_.filter(tags, function(tag) { return ( tag.Name.toUpperCase().indexOf(parent.toUpperCase()) > -1 ); });
    if ( Array.isArray(tag) )
      tag = tag[tag.length - 1];
    return tag.Name ;
  }

  static get_designer_path(parent)
  {
    var words = parent.split(/[/]+/) ;
    var designer_path = '' ;
    for ( var i = 0 ;  i <= General.category_root_level ; i ++ )
    {
      if ( words[i] !== undefined )
        designer_path += words[i] + '/';
    }
    if ( designer_path[designer_path.length-1] == '/')
      designer_path = designer_path.slice(0, -1);
    return designer_path ;
  }

  static get_metafiles(docs)
  {
    var filtered = Cx_.filter(docs, function(doc) { return ( ( doc.Class2 == Type.logo_document ) || ( doc.Class2 == Type.header_document ) ); });
    return ( filtered != undefined ) ? ( ! Array.isArray(filtered ) ) ? [filtered] : filtered : filtered ;
  }

  static reset_browser_piece(element, location)
  {
    window.AppInstance.reset()
    window.load_content$(element, location, false).then(function(){
      $('.choose-pattern-link').click();
    })    
  }

  static get_browser_piece(element, text, location, root, index)
  {
    if (root) {
      return '<span onclick="window.collection_home(true);"><span style="cursor:pointer;">'+text.charAt(0).toUpperCase() + text.slice(1)+'</span></span>';
    } else {
      return '<span onclick="window.reset_browser_piece(\''+element+'\', \''+location+'\')"><span style="cursor:pointer;">'+text.charAt(0).toUpperCase() + text.slice(1)+'</span></span>';
    }
  }

  static clear_canvas$()
  {
    var context = document.getElementById('CadXCanvas_foreground').getContext('2d');
    context.clearRect(0, 0, context.canvas.width, context.canvas.height);
    context.beginPath();
    window.AppInstance.instance().canvas.clear();
    return window.AppInstance.instance().canvas.commit$();
  }

  static load_category_metafiles$(pattern_set) {
    var deferred = new Cx$.Deferred();
    if (pattern_set.length == 0)
      return;
    var searchModel = {
      Match: {
        Owned: false,
        Shared: true,
        Tags: [{ Name: pattern_set, Owned: true, Shared: true }],
        Archived: false
      }
      , IncludeData: true
    }
    Cadx.Core.Document.search$(searchModel).then(function (response_model) {
      deferred.resolve(MetaFiles.get_metafiles(response_model.Items));
    });
    return deferred;
  }

  // ********************* TOGGLING FUNCTIONS

  static reset_selected()
  {
    selected = { colors: [], id: '', external_id: '', name: '', variationName: '',  original_zones: [], metadata: null, category: '' }
    window.AppInstance.instance().category_metafiles.pattern_name = null ;
    window.AppInstance.instance().category_metafiles.pattern_name_text = null;
    window.AppInstance.instance().category_metafiles.pattern_name_box = null ;
  }

  static reset_metafiles()
  {
    window.AppInstance.instance().category_metafiles.copyrights = null ;
    window.AppInstance.instance().category_metafiles.copyrights_text = null ;
    window.AppInstance.instance().category_metafiles.copyright_box = null ;
    window.AppInstance.instance().category_metafiles.logo = null ;
  }

  // ********************* MAIN ENTRY POINT

  static load_metafiles$(parent)
  {
    return Cx.whenAll( [MetaFiles.load_metafiles_type$(parent, Type.logo_document)
                       ,MetaFiles.load_metafiles_type$(parent, Type.header_document)])
    .then(function(r) {
      let all = [];
      Cx_.forEach(r, function(l) {
        if ( Array.isArray(l) )
          Cx_.forEach(l, function(m) {
            all = all.concat(m);
          });
        else
          all = all.concat(l);
      });
      return MetaFiles.handle_metafiles_content$(parent, all);
    });
  }

  static load_metafiles_type$(parent, classType)
  {
    var pattern_set = MetaFiles.get_designer_path(parent) ;

    if (pattern_set.length == 0)
      return;

    var searchModel = {
      Match: {
        Owned: false,
        Shared: true,
        Tags: [{ Name: pattern_set, Owned: true, Shared: true }],
        Archived: false,
        Class2: classType
      }
      , IncludeData: true
      , HasClass2: true 
    }

    let hash = GeneralHelper.md5Encode(JSON.stringify(searchModel));

    var metafiles = GeneralHelper.getPatternContainersFromLocalStorage('metafiles', hash);

    if(metafiles)
    {
      Cadx.Core.Document.search$(searchModel).then(function (r) {
        GeneralHelper.savePatternContainersToLocalStorage('metafiles', hash, r.Items);
      });
      return Cx.resolve(metafiles);
    }
    else {
      return Cadx.Core.Document.search$(searchModel).then(function (r) {
        GeneralHelper.savePatternContainersToLocalStorage('metafiles', hash, r.Items);
        //Metafiles.handle_pattern_content$(r.Items, list_children);
        return Cx.resolve(r.Items);
      });
    }
  }

  static handle_metafiles_content$(parent, items)
  {
      var metafiles = MetaFiles.get_metafiles(items);

      if ( MetaFiles.get_tag_level(parent) < General.category_root_level )
      {
        MetaFiles.reset_metafiles();

      }
      else {
        var logo   = Cx_.filter(metafiles, function(metafile) { return ( metafile.Class2 == Type.logo_document   ); });
        var header = Cx_.filter(metafiles, function(metafile) { return ( metafile.Class2 == Type.header_document ); });

        var p = [];

        if ( logo.length > 0 )
        {
          p.push(MetaFiles.create_logo_metafile$(logo));
        }
        if ( header.length > 0 )
        {
          p.push(MetaFiles.create_header_metafile$(header[0]));
        }
        return Cx.whenAll(p).then(function (metafiles) {
          return Cx.resolve(metafiles);
        });
      }
  }

  static create_logo_metafile$(logo)
  {
    var logo_figure = Cx.fromXmlString(logo[0].Cdl)[0] ;
    if ( ( logo_figure.metadata.get('type') === Type.designer ) )
    {
      var copyright_figure = new Cx.Figure.Text({
        text: logo_figure.metadata.get('copyright')
        , brush: new Cx.Brush({ color: Cx.Color.Black() })
        , font: new Cx.Font({ familyName: 'Arial' })
        , fontSize: 6
      });

      return logo_figure.bounds$().then(function(logo_bounds) {
        return copyright_figure.bounds$().then(function(copyright_bounds) {
          window.AppInstance.instance().category_metafiles.logo = logo_figure ;
          var box_color = Cx.Color({ rgb: 'FFFFFF' }) ;
          box_color.alpha = General.transparency;
          var copyright_box = Cx.Figure.Shape.CreateRectangle({
            height:  copyright_bounds.height + General.margin
            , width: copyright_bounds.width + General.margin
            , brush: Cx.Brush({ color : box_color })
            , center: copyright_bounds.center
          });
          window.AppInstance.instance().category_metafiles.copyrights = copyright_figure ;
          window.AppInstance.instance().category_metafiles.copyrights_text = logo_figure.metadata.get('copyright');
          window.AppInstance.instance().category_metafiles.copyright_box = copyright_box ;
          return Cx.resolve();
        });
      });
    }
  }
  static create_header_metafile$(header)
  {
    var header_figure = Cx.fromXmlString(header.Cdl)[0] ;
    return header_figure.bounds$().then(function(logo_bounds) {
      window.AppInstance.instance().category_metafiles.header = header_figure ;
      window.AppInstance.instance().category_metafiles.header_id = header.Id ;
      return Cx.resolve();
    });
  }
  static handle_metafiles$(parent)
  {
    if ( window.AppInstance.instance().is_fav_search )
    {
      return Category.load_logos$().then(function(logos) { 
        let designer_path = Category.get_parent_designer_location(parent);
        let cat_logo = Category.get_child_logos(logos.Items, designer_path);
        MetaFiles.create_logo_metafile$(cat_logo).then(function(logo_meta){
          return MetaFiles.render_metafiles$().then(function() {
            return Cx.resolve();
          });
        });
      });
    }
    else {
      return MetaFiles.load_metafiles$(parent).then(function() {
        return MetaFiles.render_metafiles$().then(function() {
          return Cx.resolve();
        });
      });
    }
  }

  static load_pattern_name_metafile$() //this on is separate from load_metafiles as it's called by load_pattern, in both cases render_metafiles is called after the promise
  {
    if ( window.AppInstance.instance().selected.id !== "" )
    {
      var pattern_name = window.AppInstance.instance().selected.name ;
      if ( pattern_name.indexOf('-') > -1)
        pattern_name = pattern_name.split('-')[0];
      if (pattern_name.indexOf(window.AppInstance.instance().selected.variationName) == -1 )
        pattern_name += ' ' + window.AppInstance.instance().selected.variationName ;
      var pattern_name_figure = new Cx.Figure.Text({
        text: 'Pattern Name: ' + pattern_name
        , brush: new Cx.Brush({ color: Cx.Color.Black() })
        , font: new Cx.Font({ familyName: 'Arial' })
        , fontSize: 4
      });
      return pattern_name_figure.bounds$().then(function(pattern_name_bounds) {
        var box_color = Cx.Color({ rgb: 'FFFFFF' }) ;
        box_color.alpha = General.transparency;
        var name_box = Cx.Figure.Shape.CreateRectangle({
          height:  pattern_name_bounds.height + General.margin
          , width: pattern_name_bounds.width + General.margin
          , brush: Cx.Brush({ color : box_color })
          , center: pattern_name_bounds.center
        });
        window.AppInstance.instance().category_metafiles.pattern_name = pattern_name_figure ;
        window.AppInstance.instance().category_metafiles.pattern_name_box = name_box ;
        window.AppInstance.instance().category_metafiles.pattern_name_text = 'Pattern Name: ' + pattern_name ;
        return Cx.resolve();
      });
    }
    else { return Cx.resolve() ; }
  }

  static get_browser(element, location)
  {

    var browser_html = '' ;
    var parts = location.split(/[/]+/) ;

    if ( parts.length > General.category_root_level ) {
      var base = '/' + parts[1] + '/' + parts[2] ; //index 0 is empty because of the initial slash
      browser_html += MetaFiles.get_browser_piece(element, 'Collection Home', base, true, General.category_root_level );
      for ( var i = General.category_root_level ; i < parts.length ; i++ )
      {
        var current = base ;
        for ( var j = General.category_root_level ; j <= i ; j ++ )
          current += '/' + parts[j];
        browser_html += ' > ' + MetaFiles.get_browser_piece(element, parts[i], current, false, i);
      }
    } else {
      browser_html = "Collection Home";
    }

    return browser_html ;
  }

  static render_floating_metafile$(doc, el)
  {
    return Cx.createPromise(function(resolve, reject) {
      var qs = {
      config: Cx.Core.getConfig()
        , model: {
        Id: doc.imageLink,
        AsBase64: false,
        Compress: true,
        Quantum: 512
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
    }

    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));

    var meta = GeneralHelper.getPatternContainersFromLocalStorage('metafile', hash);

    if(meta)
    {
      var img = document.createElement("img");
      img.src = meta ;
      img.onload = function()
      {
        $(el).append(img);
        return resolve();
      }
    }
    else {

      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function()
      {
        if (this.readyState == 4 && this.status == 200)
        {
          var res = this.response;
          var reader = new window.FileReader();
          reader.readAsDataURL(res);
          reader.onloadend = function() {
            var img = '<img src="' + reader.result + '" /></div></div>';
            GeneralHelper.savePatternContainersToLocalStorage('metafile', hash, reader.result);
            $(el).append(img);
            return resolve();
          }
        }
      }
      xhr.open('POST', Cx.Core.getServer() + '/Core2/Image/ReadData');
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      xhr.send(JSON.stringify(qs));
      xhr.responseType = 'blob';
      }
    });
  }

  static render_metafiles$()
  {
    $('#'+Ids.logo).remove();
    $('#'+Ids.copyrights).remove();
    $('#'+Ids.pattern_name).remove();

    var offset = $("#"+window.AppInstance.instance().canvas.containerId).offset();
    var pattern_loaded = ( window.AppInstance.instance().category_metafiles.pattern_name !== null ) && ( window.AppInstance.instance().category_metafiles.pattern_name_box !== undefined ) ;
    var logo_loaded  = ( window.AppInstance.instance().category_metafiles.logo !== null ) && ( window.AppInstance.instance().category_metafiles.logo !== undefined ) ;
    var ps = [];

    if ( window.AppInstance.browsing() === "pattern" )
    {
      ps.push(this.render_floating_metafile$(window.AppInstance.instance().category_metafiles.logo, ".expanded-pattern .logo"));
    }

    //wait for meta files to be loaded and rendered
    return Cx.whenAll(ps).then(function(){
      if ( pattern_loaded )
      {
        View.show_toolbars_tools();
        return Cx.resolve();
      }
      else {
        View.hide_toolbars_tools();
        return Cx.resolve();
      }
    });
  }

  static load_default_header$()
  {
    let searchModel = {
      Match: {
        Owned: false,
        Shared: true,
        Archived: false,
        Name: General.default_header_name,
        Quantum: 1024
      }
    }
    return Cadx.Core.Document.search$(searchModel).then(function (response) {
      return Cadx.Core.Document.read$({ Id: response.Items[0].Id });
    });
  }

  static render_floating_header$(header)
  {
    var d = Cx.createPromise(function(resolve, reject) {
    var qs = {
      config: Cx.Core.getConfig()
      , model: {
        Id: header.imageLink,
        AsBase64: false,
        Quantum: 1024
      }
      , ident: { SessionId: Cx.User.getSessionId(), SuperUser: Cx.User.isSuperUser() }
    }

    let hash = GeneralHelper.md5Encode(JSON.stringify(qs));

    var meta = GeneralHelper.getPatternContainersFromLocalStorage('metafile', hash);

    if(meta)
    {
      var img = document.createElement("img");
      img.src = meta ;
      img.onload = function()
      {
        MetaFiles.render_to_canvas(img);
        return resolve();
      }
    }
    else {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function()
        {
        if (this.readyState == 4 && this.status == 200)
        {
          var res = this.response;
          var reader = new window.FileReader();
          reader.readAsDataURL(res);
          reader.onloadend = function() {
            var img = document.createElement("img");            
            //GeneralHelper.savePatternContainersToLocalStorage('metafile', hash, reader.result);
            img.src = reader.result ;
              img.onload = function()
              {
                MetaFiles.render_to_canvas(img);
                return resolve();
              }
            }
          }
        }
        xhr.open('POST', Cx.Core.getServer() + '/Core2/Image/ReadData');
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.send(JSON.stringify(qs));
        xhr.responseType = 'blob';
      }
    });

    return d;
  }

  static render_to_canvas(img){
    let context = document.getElementById('CadXCanvas_mask').getContext('2d') //TODO. abstract accessor
    context.drawImage(img, 0, 0, img.width*2, img.height*2);
    window.AppInstance.instance().canvas.figures = [];
    window.AppInstance.instance().canvas.commit$();
  }
}